import { Action, OperationType } from "puzzle";

export const reloadSubmissionList: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'userPromise',
  type: OperationType.action
}, {
  condition: '{route() === "view/taskList"}',
  conditionOperations: [{
    name: 'loadAdvancedSearchList',
    type: OperationType.action
  }, {
    condition: `!_.get({cookieParams}, 'submissionId')`,
    conditionOperations: [{
      data: {
        template: {
          bind: {
            filter: '{filters[0]}'
          }
        }
      },
      moduleName: 'SearchBar',
      name: 'addFilterToState',
      args: ['filter'],
      waitForModule: true,
      type: OperationType.addOperationData
    }, {
      moduleName: 'SearchBar',
      name: 'prepareDataForSearch',
      args: ['filter'],
      type: OperationType.addOperationData,
      mappingName: 'mainGridFilter'
    }],
    type: OperationType.conditional
  }, {
    persistent: ['mainGridFilter'],
    type: OperationType.addPersistentData
  }],
  elseOperations: [{
    name: 'getAllFilters',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  name: 'getMainGridInitialData',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}, {
  name: 'getPreferencesForAutoRefresh',
  type: OperationType.action
}];
